import MinimalDocumentView from './MinimalDocumentView';
export default MinimalDocumentView;